<template>
  <a :href="data.gridLink" class="pgc">
    <ImageField
      class="pgc__img"
      :obj="{'url': data.bgImg, 'alt': data.gridTitle, 'width': 576, 'height': 1134}"
      :isLoadingLazy="isLoadingLazy"
    />
    <div 
      :class="['pgc__copy', data.verticalAlign]"
      :style="{
        '--text-align': data.horizontalAlign,
        '--text-color': data.gridTitleColor,
      }"
    >
      <h3 v-if="data.gridTitle" class="pgc__title">{{ data.gridTitle }}</h3>
      <p v-if="data.gridDesc" class="pgc__desc">{{ data.gridDesc }}</p>
      <button v-if="data.gridCtaText" class="btn btn--secondary pgc__cta">{{ data.gridCtaText }}</button>
    </div>
  </a>
</template>

<script setup>
  import ImageField from './image.vue';

  const props = defineProps({
    data: {
      type: Object,
      required: true,
    }
  })
</script>